module.exports = __webpack_public_path__ + "img/715-e63662.png";